export const from24To12 = (time) => {
    let split = time.split(":");
    let hours = Number(split[0]), minutes = split[1], ampm = "am";
    if(hours >= 12){
        ampm = "pm"
        if(hours > 12)
            hours -= 12
    }
    let newTime = `${hours}:${minutes}${ampm}`
    return newTime;
}


// WEBPACK FOOTER //
// ./src/services/utilities.js